import type { NavCategoryGetters } from './types';

export function useNavCategoryGetters(): NavCategoryGetters {
  return {};
}
